import { useState, useEffect, useCallback } from 'react';

function getSize() {
  const w = window.innerWidth;
  return {
    width: w,
    height: window.innerHeight,
    isMobile: w < 640,
    isTablet: w >= 640 && w < 1024,
    isDesktop: w >= 1024,
    isWide: w >= 1280,
  };
}

export function useWindowSize() {
  const [size, setSize] = useState(getSize);

  const handleResize = useCallback(() => {
    setSize(getSize());
  }, []);

  useEffect(() => {
    let rafId;
    const debounced = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(handleResize);
    };
    window.addEventListener('resize', debounced, { passive: true });
    return () => {
      window.removeEventListener('resize', debounced);
      cancelAnimationFrame(rafId);
    };
  }, [handleResize]);

  return size;
}